import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./layout/MainLayout";

// Auth
import LoginRegister from "./pages/LoginRegister";

// Admin
import AdminDashboard from "./pages/AdminDashboard";
import BackofficeFacturas from "./pages/BackofficeFacturas";
import DashboardBackoffice from "./pages/DashboardBackoffice";

// Dashboards
import DashboardCliente from "./pages/DashboardCliente";
import DashboardComprador from "./pages/DashboardComprador";

// Publicaciones (cliente)
import PublicacionesCliente from "./pages/PublicacionesCliente";

// Publicaciones (comprador)
import PublicacionesComprador from "./pages/PublicacionesComprador";
import VistaPublicaPost from "./pages/VistaPublicaPost";

// Ofertas / operaciones
import OfertasRecibidas from "./pages/OfertasRecibidas";

// Chat y pagos
import ChatOperacion from "./pages/ChatOperacion";
import PasarelaPago from "./pages/PasarelaPago";

// Bloqueos
import BloqueoCompradores from "./pages/BloqueoCompradores";

// Movimientos
import Movimientos from "./pages/Movimientos";

// Perfil
import Perfil from "./pages/Perfil";

// Notificaciones
import Notificaciones from "./pages/Notificaciones";


function PrivateRoute({ children, role }) {
  const usuario = JSON.parse(localStorage.getItem("usuario"));
  if (!usuario) return <Navigate to="/" replace />;
  if (role && usuario.role !== role) {
    return <Navigate to="/" replace />;
  }
  return children;
}

export default function App() {
  const usuario = JSON.parse(localStorage.getItem("usuario"));
  const role = usuario?.role ?? null;

  // Función helper para redirección inicial
  const getDefaultRoute = () => {
    if (role === "admin") return "/admin";
    if (role === "cliente") return "/dashboard-cliente";
    return "/dashboard-comprador";
  };

  return (
    <BrowserRouter>
      <Routes>
        {/* Ruta pública - Login */}
        <Route
          path="/"
          element={
            usuario ? (
              <Navigate to={getDefaultRoute()} replace />
            ) : (
              <LoginRegister />
            )
          }
        />

        {/* Rutas privadas con layout */}
        <Route
          element={
            <PrivateRoute>
              <MainLayout userRole={role} />
            </PrivateRoute>
          }
        >
          {/* Ruta Admin */}
          <Route
            path="/backoffice-dashboard"
            element={
              <PrivateRoute role="admin">
                <DashboardBackoffice />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute role="admin">
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/backoffice"
            element={
              <PrivateRoute role="admin">
                <BackofficeFacturas />
              </PrivateRoute>
            }
          />

          {/* Rutas Cliente */}
          <Route path="/dashboard-cliente" element={<DashboardCliente />} />
          <Route path="/publicaciones-cliente" element={<PublicacionesCliente />} />
          <Route path="/resumen-publicacion" element={<Navigate to="/dashboard-cliente" replace />} />
          <Route path="/ofertas-recibidas" element={<OfertasRecibidas />} />
          <Route path="/operacion-iniciada" element={<Navigate to="/publicaciones-cliente" replace />} />
          <Route path="/bloqueos" element={<BloqueoCompradores />} />

          {/* Rutas Comprador */}
          <Route path="/dashboard-comprador" element={<DashboardComprador />} />
          <Route path="/publicaciones-comprador" element={<PublicacionesComprador />} />
          <Route path="/post/:id" element={<VistaPublicaPost />} />
          <Route path="/pasarela" element={<PasarelaPago />} />

          {/* Rutas compartidas */}
          <Route path="/movimientos" element={<Movimientos userRole={role} />} />
          <Route path="/chat-operacion" element={<ChatOperacion userRole={role} />} />
          <Route path="/perfil" element={<Perfil />} />
          <Route path="/notificaciones" element={<Notificaciones />} />

          {/* Fallback 404 */}
          <Route path="*" element={<h2>404 - Página no encontrada</h2>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
